<template>
  <div class="card-container">
    <common-top-form
      ref="topForm"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      selectShowPower="/historyuplevel/select"
      :show="false"
    >
      <el-form-item label="操作人">
        <el-input
          v-model="formModel.operationName"
          maxlength="10"
          placeholder="请输入操作人"
        ></el-input>
      </el-form-item>
      <el-form-item label="被操作人ID">
        <el-input
          v-model="formModel.userId"
          maxlength="10"
          placeholder="请输入被操作人ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="操作日期">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="userId"
        label="被操作人ID"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="userPhone"
        label="手机号"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="oldParentName"
        label="原上级姓名"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="oldParentPhone"
        label="原上级手机号"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="newParentName"
        label="现上级姓名"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="newParentPhone"
        label="现上级手机号"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="operationName"
        label="操作人"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="操作日期"
        min-width="160"
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";

import OrganService from "service/OrganService";
import ChannelRateService from "service/ChannelRateService";
import TransactionService from "service/TransactionService";
import StatisticsService from "service/StatisticsService";
import TimeRange from "service/constant/TimeRange";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "historyuplevel",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        userId: "",
        operationName: "",
      },
      time: TimeRange.ThreeRange,
      tableData: [],
      submitService: TransactionService.memInfoParentInfoList,
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  computed: {
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      this.params = {
        userId: this.userId,
        userId: this.formModel.userId.trim(),
        operationName: this.formModel.operationName.trim(),
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.time.length) {
        this.params.startDate = this.time[0];
        this.params.endDate = this.time[1];
      }

      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.formModel = {
        userId: "",
        operationName: "",
      };
      this.time = TimeRange.ThreeRange;
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        // console.log('result',this.tableData);

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/TransactionManage/HistoryUPLevel.vue